import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {

  transform(input: Date | string): number {
    if (input) {
      if (typeof input === 'string') {
        const parts: string[] = input.split('/')
        input = new Date(parseInt(parts[2], 10), parseInt(parts[0], 10), parseInt(parts[1], 10),)
      }

      return this.calculateAge(input)
    }
  }


  private calculateAge(birthday: Date): number {
    const ageDifMs = Date.now() - birthday.getTime()
    const ageDate = new Date(ageDifMs) // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/age/age.pipe.ts